import { isUndefined } from 'lodash';
import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import './style.less';

type Props = React.PropsWithChildren<{
    title: string;
    showAdd?: boolean;
    visible?: boolean;
    showIcons?: boolean;
    showEntrance?: boolean;
    detailChildren?: React.ReactNode;
    onAdd?: () => void;
    onToggleVisible?: () => void;
    onRemove?: () => void;
    onJump2SubPanel?: () => void;
}>;

export const SimpleEffectPropsContainer: React.FC<Props> = ({
    children,
    title,
    showAdd,
    visible,
    showIcons = false,
    showEntrance = true,
    detailChildren,
    onAdd,
    onToggleVisible,
    onRemove,
    onJump2SubPanel,
}) => {
    if (!showIcons) {
        showIcons = !showAdd && !isUndefined(visible) && !isUndefined(onToggleVisible) && !isUndefined(onRemove);
    }

    const handleAdd = () => {
        if (!showAdd) return;
        if (onAdd) onAdd();
    };

    return (
        <div className="simple-effect-props-container">
            <div className="simple-effect-props-container__header">
                <div className="simple-effect-props-container__title">{title}</div>
                <div className="simple-effect-props-container__content">
                    {children}

                    {showIcons ? (
                        <div className="simple-effect-props-container__icons">
                            {showEntrance ? (
                                <div className="simple-effect-props-container__icon" onClick={onJump2SubPanel}>
                                    <IconFont name="DoubleAdjustBold" fontSize={14} />
                                </div>
                            ) : null}

                            <div className="simple-effect-props-container__icon" onClick={onToggleVisible}>
                                <IconFont name={visible ? 'VisibleBold' : 'InvisibleBold'} fontSize={14} />
                            </div>
                            <div className="simple-effect-props-container__icon" onClick={onRemove}>
                                <IconFont name="TrashCanBold" fontSize={14} />
                            </div>
                        </div>
                    ) : null}

                    {showAdd ? (
                        <div className="simple-effect-props-container__icon" onClick={handleAdd}>
                            <IconFont name="PlusCircleBold" fontSize={14} />
                        </div>
                    ) : null}
                </div>
            </div>
            <div className="simple-effect-props-container__slot">{detailChildren}</div>
        </div>
    );
};
